import { ISiteUserInfo } from '../../../userManagement/users/models/ISiteUserInfo';
import React = require('react');
import { Formik, FormikProps } from 'formik';

import { FormikCheckbox } from '~commonInfra/components/FormikCheckbox';

import { Messages } from '../../../codegen/Localize';
import { UserSettingsStyle } from '../../styles/UserSettingsStyle';
import _ = require('underscore');
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { IError } from '../../../httpClient/serverApi/types/IError';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IServerUserInfo } from '../../../userManagement/users/models/IServerUserInfo';
import { UserSettings } from '../../services/resources/UserSettings';
import { InlineCancelAndSaveButtons } from '../UserSettingEditButtons';

export type DataOrientationProps = {
    userHasNoSiteId: boolean;
    siteUser: ISiteUserInfo;
    serverUser: IServerUserInfo;
}

export interface DataOrientationAutoShowField {
    autoShowPane: boolean;
}

export const DataOrientationSectionTestId: string = 'user-settings-data-orientation';
export const DataOrientationCheckBoxTestId: string = 'auto-show-data-orientation-pane';

function showButtons(formik: FormikProps<DataOrientationAutoShowField>, autoShowPane: boolean) {
  if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.autoShowPane, autoShowPane)) {
    return false;
  }
  return true;
}

export function DataOrientationSettings(props: DataOrientationProps): JSX.Element {
  const [currentShowPane, setCurrentShowPane] = React.useState(false);

  function handleSubmit(values: DataOrientationAutoShowField, siteUser: ISiteUserInfo) {
    UserSettings.updateShouldAutoShowDataOrientationPane(
      siteUser.id, values.autoShowPane
    ).then((result: IResult) => {
      setCurrentShowPane(values.autoShowPane);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
    }).catch((error: IError) => {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
    });
  }

  React.useEffect(
    () => {
      UserSettings.getShouldAutoShowDataOrientationPane(props.serverUser.id)
      .then((result: boolean) => {
        setCurrentShowPane(result);
      }).catch((error: IError) => { });
    },
    [props.serverUser.id]
  );

  return (
    <Formik
      initialValues={{ autoShowPane: currentShowPane }}
      onSubmit={(values: DataOrientationAutoShowField) => handleSubmit(values, props.siteUser)}
      enableReinitialize={true}
    >
      {
        (formik: FormikProps<DataOrientationAutoShowField>) => (
          <form onSubmit={formik.handleSubmit}>
            <table>
              <tbody className={UserSettingsStyle.tbody}>
                <tr data-tb-test-id={DataOrientationSectionTestId}>
                  <td className={UserSettingsStyle.labelText}>
                    {Messages.dataOrientationSettingSection()}</td>
                  <td className={UserSettingsStyle.detailsValue}>
                    {Messages.dataOrientationAutoShowUserSettingDetail()}</td>
                </tr>
                <tr>
                  <td className={UserSettingsStyle.labelText}></td>
                  <td className={UserSettingsStyle.detailsValue}>
                    <FormikCheckbox
                    containerStyle={{marginLeft: 0}}
                    testId={DataOrientationCheckBoxTestId}
                    name='autoShowPane'
                    disabled={props.userHasNoSiteId}
                    label={Messages.dataOrientationUserSettingEnable()}/>
                  </td>
                </tr>
                {
                  showButtons(formik, currentShowPane) &&
                  <InlineCancelAndSaveButtons
                    testId='data-orientation'
                    formik={formik}
                  />
                }
               </tbody>
            </table>
          </form>
        )
      }
    </Formik>
  );

}